// imports section Start
import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import { useState, useEffect } from "react";
import { useTheme, styled } from "@mui/material/styles";
import { useStyles } from "../../../../assets/styles/Theme";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import { resetUserParams } from "../../../../store/ReduxUser";
import { clearCashierCart } from "../../../../store/ReduxCashierCartReducer";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import LockResetIcon from "@mui/icons-material/LockReset";
import { CardMedia } from "@mui/material";
import no_image from "../../../../assets/images/no_image.png";

// imports section End

const CashierHeaderMobile = ({ toggleTheme }) => {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const [anchorEl, setAnchorEl] = useState({});
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [checked, setChecked] = useState(true);
  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const {
    COMPCODE,
    LOCCODE,
    RESTCODE,
    USERNAME,
    COMPNAME,
    RESTNAME,
    COMPANYLOGO,
  } = SYS_USER.USER_PARAM || {};

  // Handlers start

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleMenuItemClick = (path, closeFunction) => {
    closeFunction();
    navigate(path);
  };
  const handleLogout = () => {
    dispatch(resetUserParams());
    dispatch(clearCashierCart());
    navigate("/Login");
    setAnchorEl((prev) => ({ ...prev, logout: null }));
  };

  const companyLogoUrl = COMPANYLOGO
    ? `${COMPANYLOGO.replace("~/", "")}`
    : null;
  // Handlers end

  return (
    <AppBar sx={styles.m_AI_CustomAppBar}>
      <Box
        sx={{
          ml: 1,
          display: "flex",
          // alignContent: "center",
          justifyContent: "space-between",
          // alignItems: "center",
          // justifyItems: "space-between",
          width: "100%",
          px: 2,
          pl: 5,
        }}
      >
        {/* <Toolbar sx={{ ml: 1 }}> */}
        <Box
          sx={{
            display: "flex",
            // alignItems: "center",
          }}
        >
          {/* <Link to="/CashierMobile">
            <CardMedia
              component="img"
              src={companyLogoUrl || no_image}
              sx={{
                width: 24,
                height: 24,

                borderRadius: 1,
                border: `1px solid ${theme.palette.background.paper}`,
                boxShadow: 1,
                transition: "transform 0.3s",
                "&:hover": { transform: "scale(1.1)" },
                "@media (max-width: 600px)": {
               
                },
              }}
            />
          </Link> */}
          <Typography sx={styles.m_header_title}>{RESTNAME}</Typography>
        </Box>
        <br />
        {/* <Box sx={styles.nv_CustomBox} /> */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          gap={2}
        >
          {/* User Name */}

          {/* Avatar with Tooltip */}
          <Tooltip title="Profile Options" arrow>
            <IconButton
              onClick={handleOpenUserMenu}
              sx={{
                p: 0.5,
                borderRadius: "50%",
                border: `1px solid ${theme.palette.input_field.stroke}`,
                // boxShadow:
                //   theme.palette.mode === "dark"
                //     ? "0 0 8px #333"
                //     : "0 0 8px #ddd",
                "&:hover": {
                  backgroundColor: theme.palette.action.hover,
                  transform: "scale(1.05)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  width: "16px",
                  height: "16px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  backgroundColor: theme.palette.background.default,
                }}
              >
                <AccountCircleRoundedIcon
                  sx={{
                    width: "100%",
                    height: "100%",
                    color: theme.palette.primary.main,
                  }}
                />
              </Box>
            </IconButton>
          </Tooltip>

          {/* User Menu */}
          <Menu
            sx={{
              mt: "45px",
              "& .MuiMenu-paper": {
                borderRadius: "12px",
                // boxShadow:
                //   theme.palette.mode === "dark"
                //     ? "0 4px 12px rgba(0,0,0,0.3)"
                //     : "0 4px 12px rgba(0,0,0,0.1)",
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
                padding: "8px 0",
              },
            }}
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            {/* Profile */}
            <MenuItem
              onClick={() =>
                handleMenuItemClick("/myprofile", () => setAnchorElUser(null))
              }
              sx={{
                "&:hover": {
                  backgroundColor: theme.palette.action.hover,
                  "& .MuiSvgIcon-root": {
                    color: theme.palette.secondary.main,
                  },
                },
              }}
            >
              <IconButton sx={{ mr: 1 }}>
                <AccountCircleIcon sx={{ color: theme.palette.primary.main }} />
              </IconButton>
              <Typography>My Profile</Typography>
            </MenuItem>

            {/* Change Password */}
            <MenuItem
              onClick={() =>
                handleMenuItemClick("/changepasswrd", () =>
                  setAnchorElUser(null)
                )
              }
              sx={{
                "&:hover": {
                  backgroundColor: theme.palette.action.hover,
                  "& .MuiSvgIcon-root": {
                    color: theme.palette.secondary.main,
                  },
                },
              }}
            >
              <IconButton sx={{ mr: 1 }}>
                <LockResetIcon sx={{ color: theme.palette.primary.main }} />
              </IconButton>
              <Typography>Change Password</Typography>
            </MenuItem>

            {/* Logout */}
            <MenuItem
              onClick={handleLogout}
              // sx={{
              //   "&:hover": {
              //     backgroundColor: theme.palette.error.light,
              //     "& .MuiSvgIcon-root": {
              //       color: theme.palette.error.dark,
              //     },
              //   },
              // }}
              sx={{
                "&:hover": {
                  backgroundColor: theme.palette.action.hover,
                  "& .MuiSvgIcon-root": {
                    color: theme.palette.secondary.main,
                  },
                },
              }}
            >
              <IconButton sx={{ mr: 1 }}>
                <ExitToAppIcon sx={{ color: theme.palette.primary.main }} />
              </IconButton>
              <Typography>Logout</Typography>
            </MenuItem>
          </Menu>
        </Box>
        {/* </Toolbar> */}
      </Box>
    </AppBar>
  );
};

export default CashierHeaderMobile;
